module.exports = __webpack_public_path__ + "static/media/tables-holes.svg";